import { useDataProvider, type DataProvider } from "ra-core";
import { useQuery } from "@tanstack/react-query";

import type { Deal } from "@/components/atomic-crm/types";

// Below the 1000 rows that the Supabase API returns at most per request
export const PIPELINE_DEALS_PAGE = 500;

// Every deal matching the filter, a page at a time until the total
export const fetchAllDeals = async (
  getList: DataProvider["getList"],
  filter: Record<string, unknown>,
): Promise<Deal[]> => {
  const deals: Deal[] = [];
  for (let page = 1; ; page++) {
    const { data, total } = await getList<Deal>("deals", {
      pagination: { page, perPage: PIPELINE_DEALS_PAGE },
      sort: { field: "index", order: "ASC" },
      filter,
    });
    deals.push(...data);
    const isDone =
      data.length < PIPELINE_DEALS_PAGE ||
      (total != null && deals.length >= total);
    if (isDone) return deals;
  }
};

// Every deal of the pipeline shown, with the filters of the deals list
// (search, organization, categories, owner): the board and the phone list
// group them by stage, so counts and totals per stage are the real ones.
// The key starts with "deals", so every deal mutation of react-admin
// refreshes it.
export const usePipelineDeals = (filter: Record<string, unknown>) => {
  const dataProvider = useDataProvider();
  return useQuery({
    queryKey: ["deals", "tenax_pipeline_deals", filter],
    enabled: filter.pipeline_id != null,
    queryFn: () => fetchAllDeals(dataProvider.getList, filter),
  });
};
